<template>
  <transition name="fade">
    <div v-if="show" class="mask" @click.self="closeMask">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["show"],
  methods: {
    closeMask() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  @include vc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>